import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import {
// getSnapshot,
types, getParent, getRoot } from 'mobx-state-tree';
import { toJS } from 'mobx';
import { BillingTemplateModel, UtilityProviderModel } from './billingTemplates';
import { UtilityTemplateModel } from './oldUtilityTemplate';
import { FeeSetupModel } from './feeSetup';
import { UnitSetupModel } from './unitSetup';
import moment from 'moment';
import { PaymentSetupModel } from './paymentSetup';
import { glCodeSetupModel } from './glCodeSetup';
import { PropertyAmenityModel } from './propertyModels/propertyAnemityModel';
export const PropertyDetailsModel = types.model('PropertyDetailsModel', {
  // id: types.string,
  billingTemplates: types.optional(types.array(BillingTemplateModel), []),
  billingTemplateModalForm: types.optional(BillingTemplateModel, {}),
  billingTemplatesLastFetchTime: types.optional(types.number, moment().toDate().getTime()),
  propertyUtilityProviders: types.optional(types.array(UtilityProviderModel), []),
  utilityTemplates: types.optional(types.array(UtilityTemplateModel), []),
  utilityTemplateModalForm: types.optional(UtilityTemplateModel, {}),
  utilityTemplatesLastFetchTime: types.optional(types.number, moment().toDate().getTime()),
  // reimbursementInformation: types.optional(types.string, 'reimbursement_id'), // NOTE: not used yet
  units: types.optional(types.array(types.string), []),
  feeSetup: types.optional(FeeSetupModel, {}),
  unitSetup: types.optional(UnitSetupModel, {}),
  paymentSetup: types.optional(PaymentSetupModel, {}),
  glCodeSetup: types.optional(glCodeSetupModel, {}),
  glCodeSetupLastFetchTime: types.optional(types.number, moment().toDate().getTime()),
  amenities: types.optional(types.array(PropertyAmenityModel), []),
  amenityModalForm: types.optional(PropertyAmenityModel, {}),
  amenitiesLastFetchTime: types.optional(types.number, moment().toDate().getTime())
}).actions(store => {
  return {
    setBillingTemplates(data) {
      store.billingTemplates = data;
    },
    setBillingTemplateModalForm(data) {
      store.billingTemplateModalForm = toJS(data);
    },
    fetchBillingTemplates() {
      var _store$billingTemplat;
      let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        forceUpdate: false,
        useUnicInProgress: true,
        customUnicInProgress: []
      };
      if (getParent(store).id && (moment().diff(moment(store.billingTemplatesLastFetchTime), 'minutes') >= 5 || !((_store$billingTemplat = store.billingTemplates) !== null && _store$billingTemplat !== void 0 && _store$billingTemplat.length) || !!(params !== null && params !== void 0 && params.forceUpdate))) {
        var _params$customUnicInP, _params$customUnicInP2;
        getRoot(store).propertyUtility.getPropertyUtilitiesByPropertyAsync.run({
          propertyId: getParent(store).id
        }, params.useUnicInProgress && !(params !== null && params !== void 0 && (_params$customUnicInP = params.customUnicInProgress) !== null && _params$customUnicInP !== void 0 && _params$customUnicInP.length) ? [getParent(store).id] : !!(params !== null && params !== void 0 && (_params$customUnicInP2 = params.customUnicInProgress) !== null && _params$customUnicInP2 !== void 0 && _params$customUnicInP2.length) ? params === null || params === void 0 ? void 0 : params.customUnicInProgress : null).then(resp => {
          if (resp !== null && resp !== void 0 && resp.isSuccessful) {
            if (resp !== null && resp !== void 0 && resp.isSuccessful) {
              store.setBillingTemplates(resp.response.map(i => _objectSpread(_objectSpread({}, i), {}, {
                vacantUnitUsageLimit: i.vacantUnitUsageLimit !== null ? Number(i.vacantUnitUsageLimit * 100) : i.vacantUnitUsageLimit
              })));
            }
          }
        });
      }
    },
    setUtilityTemplates(data) {
      store.utilityTemplates = data;
    },
    setUtilityTemplateModalForm(data) {
      store.utilityTemplateModalForm = toJS(data);
    },
    fetchUtilityTemplates() {
      var _store$utilityTemplat;
      let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        forceUpdate: false,
        useUnicInProgress: true,
        customUnicInProgress: []
      };
      if (getParent(store).id && (moment().diff(moment(store.utilityTemplatesLastFetchTime), 'minutes') >= 5 || !((_store$utilityTemplat = store.utilityTemplates) !== null && _store$utilityTemplat !== void 0 && _store$utilityTemplat.length) || !!(params !== null && params !== void 0 && params.forceUpdate))) {
        var _params$customUnicInP3, _params$customUnicInP4;
        return getRoot(store).properties.getPropertyUtilityProvidersV3Async.run({
          propertyId: getParent(store).id
        }, params.useUnicInProgress && !(params !== null && params !== void 0 && (_params$customUnicInP3 = params.customUnicInProgress) !== null && _params$customUnicInP3 !== void 0 && _params$customUnicInP3.length) ? [getParent(store).id] : !!(params !== null && params !== void 0 && (_params$customUnicInP4 = params.customUnicInProgress) !== null && _params$customUnicInP4 !== void 0 && _params$customUnicInP4.length) ? params === null || params === void 0 ? void 0 : params.customUnicInProgress : null).then(resp => {
          if (resp !== null && resp !== void 0 && resp.isSuccessful) {
            store.setUtilityTemplates(resp.response.reduce((acc, current) => {
              var _current$utilities;
              if ((_current$utilities = current.utilities) !== null && _current$utilities !== void 0 && _current$utilities.length) {
                current.utilities.forEach(utility => {
                  var _current$scraperProvi;
                  acc.push(_objectSpread(_objectSpread({}, utility), {}, {
                    vacantUnitUsageLimit: utility.vacantUnitUsageLimit !== null ? Number(utility.vacantUnitUsageLimit * 100) : utility.vacantUnitUsageLimit,
                    provider: {
                      id: current === null || current === void 0 ? void 0 : current.id,
                      utilityProviderId: current === null || current === void 0 ? void 0 : current.utilityProviderId,
                      utilityProviderName: current === null || current === void 0 ? void 0 : current.utilityProviderName,
                      website: current === null || current === void 0 ? void 0 : current.website,
                      billsDownloadNeeded: current === null || current === void 0 ? void 0 : current.billsDownloadNeeded,
                      isCustom: current === null || current === void 0 ? void 0 : current.isCustom,
                      isAppAutomationEnabled: current === null || current === void 0 ? void 0 : current.isAppAutomationEnabled,
                      scraperProviderKey: (_current$scraperProvi = current === null || current === void 0 ? void 0 : current.scraperProviderKey) !== null && _current$scraperProvi !== void 0 ? _current$scraperProvi : null
                    }
                  }));
                });
              }
              return acc;
            }, []));
          }
        });
      }
    },
    setPropertyUtilityProviders(data) {
      store.propertyUtilityProviders = toJS(data);
    },
    fetchPropertyUtilityProviders() {
      var _getParent, _params$customUnicInP5, _getParent2, _params$customUnicInP6;
      let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        useUnicInProgress: true,
        customUnicInProgress: []
      };
      return getRoot(store).properties.getPropertyUtilityProvidersV3Async.run({
        propertyId: (_getParent = getParent(store)) === null || _getParent === void 0 ? void 0 : _getParent.id
      }, params.useUnicInProgress && !(params !== null && params !== void 0 && (_params$customUnicInP5 = params.customUnicInProgress) !== null && _params$customUnicInP5 !== void 0 && _params$customUnicInP5.length) ? [(_getParent2 = getParent(store)) === null || _getParent2 === void 0 ? void 0 : _getParent2.id] : !!(params !== null && params !== void 0 && (_params$customUnicInP6 = params.customUnicInProgress) !== null && _params$customUnicInP6 !== void 0 && _params$customUnicInP6.length) ? params === null || params === void 0 ? void 0 : params.customUnicInProgress : null).then(resp => {
        if (resp !== null && resp !== void 0 && resp.isSuccessful) {
          const oldUtilitiesNeedExtraUtInfoFetch = [];
          store.setPropertyUtilityProviders(resp.response.map(provider => _objectSpread(_objectSpread({}, provider), {}, {
            utilities: provider.utilities.map(utility => {
              if (utility.utilityType === '') {
                oldUtilitiesNeedExtraUtInfoFetch.push({
                  utilityId: utility.utilityId,
                  id: utility.id
                });
              }
              return _objectSpread(_objectSpread({}, utility), {}, {
                utilityTypeId: utility.utilityId,
                utilityTypeName: utility.utilityType
              });
            })
          })));
          if (!!oldUtilitiesNeedExtraUtInfoFetch.length) {
            var _getRoot$homeDashboar;
            (_getRoot$homeDashboar = getRoot(store).homeDashboardStore.getCurrentCompany) === null || _getRoot$homeDashboar === void 0 || _getRoot$homeDashboar.fetchOldUtilitiesInfo(oldUtilitiesNeedExtraUtInfoFetch);
          }
        }
      });
    },
    setAmenities(data) {
      store.amenities = data;
      store.amenitiesLastFetchTime = moment().toDate().getTime();
    },
    setAmenityModalForm(data) {
      store.amenityModalForm = toJS(data);
    },
    fetchAmenities() {
      var _store$amenities;
      let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        forceUpdate: false,
        useUnicInProgress: true,
        customUnicInProgress: []
      };
      if (getParent(store).id && (moment().diff(moment(store.amenitiesLastFetchTime), 'minutes') >= 5 || !((_store$amenities = store.amenities) !== null && _store$amenities !== void 0 && _store$amenities.length) || !!(params !== null && params !== void 0 && params.forceUpdate))) {
        var _params$customUnicInP7, _params$customUnicInP8;
        getRoot(store).utilityProviders.getPropertyCommonAreaAmenitiesAsync.run({
          propertyId: getParent(store).id
        }, params.useUnicInProgress && !(params !== null && params !== void 0 && (_params$customUnicInP7 = params.customUnicInProgress) !== null && _params$customUnicInP7 !== void 0 && _params$customUnicInP7.length) ? [getParent(store).id] : !!(params !== null && params !== void 0 && (_params$customUnicInP8 = params.customUnicInProgress) !== null && _params$customUnicInP8 !== void 0 && _params$customUnicInP8.length) ? params === null || params === void 0 ? void 0 : params.customUnicInProgress : null).then(resp => {
          if (resp !== null && resp !== void 0 && resp.isSuccessful) {
            store.setAmenities(resp.response.map(i => _objectSpread({}, i)));
          }
        });
      }
    },
    setPropertyGlCodeSetup(data) {
      store.glCodeSetup.setGlCodesAfterLoad(data);
      store.glCodeSetupLastFetchTime = moment().toDate().getTime();
    },
    fetchPropertyAppfolioGlCodes() {
      let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        forceUpdate: false,
        useUnicInProgress: true,
        customUnicInProgress: []
      };
      if (getParent(store).id && (moment().diff(moment(store.glCodeSetupLastFetchTime), 'minutes') >= 5 || !!(params !== null && params !== void 0 && params.forceUpdate))) {
        var _params$customUnicInP9, _params$customUnicInP0;
        return getRoot(store).credentials.getAppfolioPropertiesAsync.run({}, params.useUnicInProgress && !(params !== null && params !== void 0 && (_params$customUnicInP9 = params.customUnicInProgress) !== null && _params$customUnicInP9 !== void 0 && _params$customUnicInP9.length) ? [getParent(store).id] : !!(params !== null && params !== void 0 && (_params$customUnicInP0 = params.customUnicInProgress) !== null && _params$customUnicInP0 !== void 0 && _params$customUnicInP0.length) ? params === null || params === void 0 ? void 0 : params.customUnicInProgress : null).then(resp => {
          if (resp !== null && resp !== void 0 && resp.isSuccessful) {
            var _resp$response;
            const currentPropertyData = resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.find(i => {
              var _getRoot$homeDashboar2;
              return i.propertyLivableId === ((_getRoot$homeDashboar2 = getRoot(store).homeDashboardStore.getCurrentProperty) === null || _getRoot$homeDashboar2 === void 0 ? void 0 : _getRoot$homeDashboar2.id);
            });
            store.setPropertyGlCodeSetup(currentPropertyData);
          }
        });
      }
    }
  };
}).views(store => ({
  get billingTemplatesList() {
    return store.billingTemplates;
  },
  get getBillingTemplateModalForm() {
    return store.billingTemplateModalForm;
  },
  get utilityTemplatesList() {
    return store.utilityTemplates;
  },
  get getUtilityTemplateModalForm() {
    return store.utilityTemplateModalForm;
  },
  get getAmenityModalForm() {
    return store.amenityModalForm;
  },
  getPropertyUtilityProvider(providerId) {
    return store.propertyUtilityProviders.find(provider => provider.utilityProviderId === providerId) || null;
  }
  // NOTE: not used
  // getBillingTemplateById(propertyUtilityId) {
  //   return store.billingTemplates.find(template => template.propertyUtilityId === propertyUtilityId);
  // },
}));